<template>
  <div class="alignCenter">
    <van-nav-bar
      id="reset"
      title="首页"
      right-text="退出"
      @click-right="onClickRight"
    />
    <div v-if="hasBooked">
      <van-notice-bar
        color="#1989fa"
        background="#ecf9ff"
        left-icon="info-o"
      >
        您已预约，请查看预约记录！
      </van-notice-bar>
    </div>

    <van-image v-else
      width="80%"
      height="auto"
      fit="contain"
      :src="bookBtn"
      style="margin: 20px auto"
      @click="makeAppointment"
    />

    <van-image
      width="70%"
      height="auto"
      fit="contain"
      :src="bookSteps"
      style="margin: 10px auto 80px auto"
    />

    <van-tabbar
      class="bottomBar"
      active-color="#FFFFFF"
      inactive-color="#FFFFFF"
    >
      <van-tabbar-item name="home" icon="home-o" @click="goToIndex"
        >首页</van-tabbar-item
      >
      <van-tabbar-item name="setting" icon="setting-o" @click="goToBookRecord"
        >预约记录</van-tabbar-item
      >
    </van-tabbar>
  </div>
</template>

<script type="text/ecmascript-6">
import bookSteps from "../../../assets/steps/bookSteps.png";
import bookBtn from "../../../assets/booBtn.png";
import { getUserBookedResource } from "../../../api/userService";

export default {
  name: "myMain",
  data() {
    return {
      hasBooked: "false",
      bookSteps: bookSteps,
      bookBtn: bookBtn,
      teleNum: sessionStorage.getItem("teleNum"),
    };
  },
  // 创建完毕状态(里面是操作)
  created() {
    this._getUserBookedResource();
    // document.querySelector(".van-nav-bar__title")[0].color = "white";
  },
  beforeCreate() {},
  beforeDestroy() {
    // document.body.removeAttribute("class", "add_bg");
  },
  // 里面的函数只有调用才会执行
  methods: {
    //获取用户预约的资源
    _getUserBookedResource() {
      getUserBookedResource(this.teleNum)
        .then((res) => {
          //如果接口调用成功，且有预约资源（res.data存在 ）
          if (res.success) {
            this.hasBooked = true;
            //如果有预约记录,则将状态设置为已经预约
            // this.$notify({
            //   type:'success',
            //   message:"您已预约，请进入预约记录查看",
            // })
          } else {
            this.hasBooked = false;
            // this.$notify({
            //   type:'warning',
            //   message:"您还未预约，请预约！",
            // })
          }
        })
        .catch((e) => {
          this.$notify({
            message: e,
            type: "error",
          });
        });
    },
    onClickRight() {
      this.$router.push({ path: "/appLogin" });
    },
    makeAppointment() {
      this.$router.push({ path: "/appIndex/basicInfo" });
    },
    goToBookRecord() {
      this.$router.push({ path: "/appIndex/appointmentResult" });
    },
    goToIndex() {
      this.$router.push({ path: "/appIndex/main" });
    },
  },
};
</script>

<style scoped>

/**style for top bar */
.van-nav-bar {
  background: linear-gradient(to right, #77bbe3, #1270c6);
}
#reset /deep/ .van-ellipsis {
  font-size: 18px;
  color: white !important;
}
#reset /deep/ .van-nav-bar__text {
  color: white !important;
}
/** top bar style end*/

div.alignCenter {
  text-align: center;
}

.medium-btn {
  width: 100% !important;
  margin: 10px auto;
  background-image: url("../../../assets/bookBtnBg.png");
}
.topBar {
  background: linear-gradient(to bottom, #77bbe3, #1270c6);
}
.bottomBar {
  background: linear-gradient(to bottom, #77bbe3, #1270c6);
}

/* 
.van-tabs__wrap {
        touch-action: manipulation;
    } */
</style>